import React from 'react';
import { IconProps } from 'react/types/icon';

const IconChevronLeft = ({ width, height, color, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color || 'currentColor'}
        d="M14.3705 17.2518C14.7239 16.8775 14.7239 16.2925 14.3705 15.9182L10.6716 12L14.3705 8.0818C14.7239 7.70749 14.7239 7.12251 14.3705 6.7482C13.9872 6.34213 13.3412 6.34213 12.9579 6.7482L8.89926 11.0474C8.39446 11.5822 8.39446 12.4178 8.89926 12.9526L12.9579 17.2518C13.3412 17.6579 13.9872 17.6579 14.3705 17.2518Z"
      />
    </svg>
  );
};

export default IconChevronLeft;
